import List from '@pelckmans/elementis/components/list';
import { useContext } from 'react';
import type { UserMaterial } from '../../../../../api/user-material';
import { ANALYTICS_EVENT_SUBLOCATIONS } from '../../../../../constants/analyticsEvents';
import ModuleContext from '../../../_contexts/ModuleContext';
import SelectionContext from '../../_contexts/SelectionContext';
import TableOfContentsContext from '../../_contexts/TableOfContentsContext';
import MaterialListHeader from '../MaterialListHeader';
import UserMaterialItem from '../../../components/UserMaterialItem';
import useUserMaterial from '../../hooks/user-material/useUserMaterial';

type UserMaterialListProps = {
  userMaterial: UserMaterial[];
  title: string;
};

export default function UserMaterialList({ userMaterial, title }: UserMaterialListProps) {
  const { selectedNode, nodes } = useContext(TableOfContentsContext);
  const { selectedModule } = useContext(ModuleContext);
  const { showSelection, selectedUserMaterials, addUserMaterials, removeUserMaterials } = useContext(SelectionContext);
  const { fetchUserMaterial } = useUserMaterial();

  if (!selectedModule || !selectedNode) return null;

  return (
    <List>
      <MaterialListHeader<UserMaterial>
        title={title}
        showSelection={showSelection}
        selectedMaterial={selectedUserMaterials}
        material={userMaterial}
        addMaterial={addUserMaterials}
        removeMaterial={removeUserMaterials}
      />
      {userMaterial.map((material: UserMaterial) => (
        <UserMaterialItem
          key={material.id}
          userMaterial={material}
          canBePinned
          nodes={nodes}
          module={selectedModule}
          subLocationId={ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_MODULE_OTHER_MATERIAL}
          refetch={() => fetchUserMaterial(false)}
          isShared={material.shared}
        />
      ))}
    </List>
  );
}
